import React from 'react'
import * as typeformEmbed from '@typeform/embed'
import Feature from '../elements/Feature'

export default (props) => {
  let typeForm
  if (process && process.browser) {
    typeForm = typeformEmbed.makePopup(
      props.buttonUrl,
      {
        opacity: 55,
        buttonText: "Request Invite",
        hideScrollbars: true,
        onSubmit: function () {
          setTimeout(() => typeForm.close(), 2000)
        }
      }
    )
  }
  return <div className="section features">
    <div className="container">
      <div className="row">
        <div className="col-12 col-md-11 mx-auto">
          <h2 className="text-center">{props.featureTitle ? props.featureTitle : 'Features'}</h2>
          <div className="row">
            {props.allFeatures.map((feature, key) => <Feature {...feature} key={key} id={key} />)}
          </div>
        </div>
        <div className="col-12 col-md-11 mx-auto text-center">
          <div className="sm-space"></div>
          {/* eslint-disable-next-line  */}
          <a
            href="#"
            onClick={() => {
              process && process.browser &&
                typeForm.open()
            }}
            className="btn mb-2 sm-font pirlo-btn">
            {props.buttonText ? props.buttonText : "Request Invite"}
          </a>
        </div>
      </div>
    </div>
    <div id="team"></div>
  </div>
};
